module.exports = __webpack_public_path__ + "static/media/trainVideo7.147f6a11.mp4";